import 'style/_colors.scss';
import {byteUtils} from 'util/bytes.js';
const CHART_BACKUPS_SMALL = 300;


/* eslint-disable no-magic-numbers */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable max-params */

export const getObjectChartOccupancy = series => ({
    chart: {
        type: 'pie'
    },
    title: {
        text: ''
    },
    plotOptions: {
        series: {
            dataLabels: {
                enabled: true,
                format:  '{point.name}: {point.y}'
            }
        },
        showInLegend: true
    },
    tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:  '<span style="color:{point.color}">Class: {point.name}</span>: <b>{point.percentage:.1f}%</b>'
    },

    series
});

export const getChartOccupancy = series => ({
    chart: {
        type: 'pie'
    },
    title: {
        text: ''
    },
    plotOptions: {
        series: {
            dataLabels: {
                enabled: true,
                format:  '{point.name}: {point.y}'
            }
        },
        showInLegend: true
    },
    tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:  '<span style="color:{point.color}">Class: {point.name}</span>: <b>{point.percentage:.1f}%</b>'
    },

    series
});

/**
 * Last 13 months chart
 * @type Object
 */
export const getStackedBarChartBasicConfig = formatNumber => ({
    chart: {
        type:    'column',
        spacing: [10, 0, 0, 0],
        height:  CHART_BACKUPS_SMALL
    },
    title:  null,
    legend: {
        layout:        'horizontal',
        align:         'center',
        verticalAlign: 'bottom',
        floating:      false,
        itemStyle:     {
            fontSize: '12px'
        }
    },
    xAxis: {
        gridLineColor: '#ddd',
        gridLineWidth: 0,
        type:          'category'
    },
    yAxis: {
        title:  null,
        labels: {
            formatter() {
                return `${this.value}TB`;
            }
        }
    },
    tooltip: {
        shared: true,


        formatter() {
                        let toolTipString = '';

            this.points.forEach((point, index) => {
                const monthString = this.points[0].key.charAt(0).toUpperCase() + this.points[0].key.slice(1);
                const averageString = point.series.name.charAt(0).toUpperCase() + point.series.name.slice(1);
                
                toolTipString += `<span style="color:${point.color}">\u25CF</span> 
                    ${index === 0 ? monthString : averageString}: <b>
                    ${byteUtils.convertBytesAndFormatWithSymbol(point.y, formatNumber, "TB")}</b><br/>`;
            });

            return toolTipString;
        }
    },
    plotOptions: {
        column: {
            fillOpacity: 0.4,
            lineWidth:   1,
            marker:      {
                radius: 3
            }
        },
        spline: {
            marker: {
                enabled: false
            }
        }
    }
});

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/containers/storage/config/charts.js